import { ddayKst } from '@/lib/cl-core/kst';
import { eokShort } from '@/lib/fmt';
// lib/apt-format.ts
/** RD-3 C2 G22 — 화면에 나가는 수량(세대·건·명·곳·개)은 천 단위 쉼표. 숫자가 아니면 그대로 문자열화(「?」 등). */
export function fmtCnt(v: unknown): string {
  const n = typeof v === 'number' ? v : (typeof v === 'string' && v.trim() !== '' ? Number(v) : NaN);
  return Number.isFinite(n) ? n.toLocaleString('ko-KR') : String(v ?? '');
}

/** 만원 → 정본 짧은 표기(lib/fmt eokShort · 버림). 결측·0 → 「—」(이 모듈의 계약). */
export function formatKoreanPrice(amount: number | null | undefined): string {
  return eokShort(amount) ?? '—';
}

/**
 * D-day(KST 달력). HC 정리(2026-10-24) — 종전 식은 서버 로컬 자정으로 잘라(setHours(0)) UTC 서버에서
 *   KST 00:00~09:00 사이 «오늘» 을 전날로 보고 하루 늦게 셌다. 정본 cl-core/kst ddayKst.
 */
export function calcDday(dateStr: string | null | undefined, now: Date | number = Date.now()): number | null {
  return ddayKst(dateStr, now);
}
